import { createAction, props } from '@ngrx/store';

// Load Email Signature from Logged In User
export const loadEmailSignatureFromLoggedInUser = createAction('[UserProfile] Load Email Signature From Logged In User', props<{ organizationId: string }>());
export const loadEmailSignatureFromLoggedInUserSuccess = createAction('[UserProfile] Load Email Signature From Logged In User Success', props<{ emailSignature: string }>());
export const loadEmailSignatureFromLoggedInUserFailure = createAction('[UserProfile] Load Email Signature From Logged In User Failure', props<{ error: any }>());
